import { gql } from '@apollo/client'

import { USER_ADDRESS_FRAGMENT } from '../../AddressBookPage/fragments/addressFragment'
import { PERSONAL_DETAILS_FRAGMENT } from '../../PersonalDetailsPage/fragments/personalDetailsFragment'

const USER_FRAGMENT = gql`
  ${PERSONAL_DETAILS_FRAGMENT}
  ${USER_ADDRESS_FRAGMENT}
  fragment userFragment on User {
    id
    ...personalDetailsFragment
    ...UserAddressFragment
  }
`

export { USER_FRAGMENT }
